import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleLogoComponent } from '../google-logo/google-logo.component';

@Component({
  selector: 'google-button',
  imports: [CommonModule, GoogleLogoComponent],
  templateUrl: './google-button.component.html',
  styleUrl: './google-button.component.css',
  standalone: true
})
export class GoogleButtonComponent {
  @Input() buttonText: string = 'Sign in with Google';
  @Output() buttonClick = new EventEmitter<void>();

  onClick(): void {
    this.buttonClick.emit();
  }
}
